angular.module('callX').controller('CallSetupStationCtrl', ['$scope', '$modalInstance', '$state', 'UserService', 'object', '$timeout', 'toaster', function($scope, $modalInstance, $state, UserService, object, $timeout, toaster) {

    $scope.obj = object;
    // $scope.status = $scope.obj.status,
    $scope.firstName = $scope.obj.firstName;
    $scope.lastName = $scope.obj.lastName;
    var userAgentId = $scope.obj.id;
    var role = $scope.obj.role;

    // Audio device selection — use object for ng-model so ng-if child scopes
    // write through prototypal inheritance correctly (classic AngularJS gotcha).
    $scope.audioInputDevices = $scope.obj.audioInputDevices || [];
    $scope.audioOutputDevices = $scope.obj.audioOutputDevices || [];
    $scope.deviceSelection = {
      inputId: $scope.obj.selectedAudioInputDeviceId || '',
      outputId: $scope.obj.selectedAudioOutputDeviceId || ''
    };
    var parentApplyAudioDeviceSettings = $scope.obj.applyAudioDeviceSettings;
    var audioOutputTestVolumePreferenceKey = 'callxSalesAudioOutputTestVolume';
    var audioOutputTestVolumeChangedEventName = 'callx:sales-audio-output-test-volume-changed';

    function normalizeAudioDeviceLabel(label) {
      return (label || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function getAudioDeviceLabel(device, index) {
      if (device.deviceId === 'default') {
        return (device.label && device.label.trim()) || (device.kind === 'audioinput' ? 'System Default Microphone' : 'System Default Speaker');
      }
      if (device.label && device.label.trim()) {
        return device.label;
      }
      return device.kind === 'audioinput' ? ('Microphone ' + (index + 1)) : ('Speaker ' + (index + 1));
    }

    function buildUniqueAudioDeviceList(devices, kind) {
      var uniqueDevices = [];
      var seenKeys = {};
      var physicalIndex = 0;
      var hasDefault = false;
      devices
        .filter(function(d) { return d.kind === kind && d.deviceId && d.deviceId !== 'communications'; })
        .forEach(function(d) {
          if (d.deviceId === 'default') {
            if (hasDefault) { return; }
            hasDefault = true;
            uniqueDevices.unshift({
              deviceId: d.deviceId,
              label: getAudioDeviceLabel(d, 0),
              kind: kind,
              groupId: d.groupId || '',
              isDefault: true,
            });
            return;
          }
          var rawLabelKey = normalizeAudioDeviceLabel(d.label || '');
          var uniqueKey = kind + '|' + (d.groupId || '') + '|' + (rawLabelKey || d.deviceId);
          if (seenKeys[uniqueKey]) { return; }
          seenKeys[uniqueKey] = true;
          uniqueDevices.push({
            deviceId: d.deviceId,
            label: getAudioDeviceLabel(d, physicalIndex),
            kind: kind,
            groupId: d.groupId || '',
            isDefault: false,
          });
          physicalIndex++;
        });
      return uniqueDevices;
    }

    function clampSpeakerTestVolume(volume, fallback) {
      var normalized = Number(volume);
      if (isNaN(normalized)) {
        normalized = typeof fallback === 'number' ? fallback : 30;
      }
      return Math.max(0, Math.min(100, Math.round(normalized)));
    }

    function readPersistedSpeakerTestVolume() {
      try {
        return clampSpeakerTestVolume(localStorage.getItem(audioOutputTestVolumePreferenceKey), 30);
      } catch (_) {
        return 30;
      }
    }

    function persistSpeakerTestVolume(volume) {
      var normalized = clampSpeakerTestVolume(volume, 30);
      try {
        localStorage.setItem(audioOutputTestVolumePreferenceKey, String(normalized));
      } catch (_) {}
      try {
        window.dispatchEvent(new Event(audioOutputTestVolumeChangedEventName));
      } catch (_) {}
      return normalized;
    }

    function syncVolumeControlVisual(volume) {
      var volumeControl = document.querySelector('.custom-volume-control');
      if (volumeControl) {
        volumeControl.style.setProperty('--value', volume + '%');
      }
    }

    $scope.onInputDeviceChange = function() {
      var inputId = $scope.deviceSelection.inputId;
      var outputId = $scope.deviceSelection.outputId;
      if (parentApplyAudioDeviceSettings) {
        parentApplyAudioDeviceSettings(inputId, outputId);
      }
      // Restart mic test with newly selected device if mic is active
      if ($scope.isMicrophoneOn) {
        $scope.stopMicrophoneLevel();
        $timeout(function() { $scope.startMicrophoneLevel(); }, 300);
      }
    };

    $scope.onOutputDeviceChange = function() {
      var inputId = $scope.deviceSelection.inputId;
      var outputId = $scope.deviceSelection.outputId;
      if (parentApplyAudioDeviceSettings) {
        parentApplyAudioDeviceSettings(inputId, outputId);
      }
      // Route speaker test audio to newly selected output device
      // The audio element is piped through an AudioContext (for the visualizer),
      // so we must call setSinkId on the AudioContext, not the <audio> element.
      var sinkId = outputId === 'default' ? '' : outputId;
      if (speakerTestAudioContext && speakerTestAudioContext.setSinkId && outputId) {
        speakerTestAudioContext.setSinkId(sinkId).catch(function(err) {
          console.error('Failed to set AudioContext sink:', err);
        });
      }
      // Also set on the audio element as fallback
      var audioEl = document.getElementById('audioElement');
      if (audioEl && audioEl.setSinkId && outputId) {
        audioEl.setSinkId(sinkId).catch(function(err) {
          console.error('Failed to set audio element sink:', err);
        });
      }
    };

    $scope.refreshDeviceList = function() {
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices().then(function(devices) {
          $scope.audioInputDevices = buildUniqueAudioDeviceList(devices, 'audioinput');
          $scope.audioOutputDevices = buildUniqueAudioDeviceList(devices, 'audiooutput');
          $scope.$applyAsync();
        });
      }
    };

    // Refresh device list on load to ensure labels are populated
    $scope.refreshDeviceList();

    // console.log($scope.obj, "get object")
    $scope.showCallStatusPrompt = true;
    $scope.speakerTestPassed = false;

    $scope.cancel = function () {
        $modalInstance.close(false);
    }; 

    $scope.step = 0; 
    $scope.progress = 0;

    //microphone test 
    var audioContext = null;
    var analyser = null;
    var microphone;
    var mediaStream;  // Define mediaStream at the controller level
    var speakerTestAudioContext = null; // AudioContext for the speaker test visualizer

    $scope.startMicrophoneLevel = function () {
        var constraints = { audio: true };
        if ($scope.deviceSelection.inputId && $scope.deviceSelection.inputId !== 'default') {
          constraints.audio = { deviceId: { exact: $scope.deviceSelection.inputId } };
        }
    
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia(constraints).then(
            function (stream) {
              audioContext = new (window.AudioContext || window.webkitAudioContext)();
              analyser = audioContext.createAnalyser();
              microphone = audioContext.createMediaStreamSource(stream);
              mediaStream = stream;  // Assign the stream to mediaStream
              microphone.connect(analyser);
              analyser.fftSize = 256;
    
              var bufferLength = analyser.frequencyBinCount;
              var dataArray = new Uint8Array(bufferLength);
              var bars = document.querySelectorAll('.audio-progress .bar');
    
              $scope.$applyAsync(function () {
                $scope.microphoneLevel = 0;
              });
    
              function updateMicrophoneLevel() {
                analyser.getByteFrequencyData(dataArray);
                var total = 0;
                for (var i = 0; i < bufferLength; i++) {
                  total += dataArray[i];
                }
                var average = total / bufferLength;
                $scope.$applyAsync(function () {
                  $scope.microphoneLevel = average;
                });
    
                var meterValue = average;
    
                if (average < 15) {
                  meterValue = 0;
                } else if (average < 20) {
                  meterValue = 1;
                } else if (average < 30) {
                  meterValue = 2;
                } else if (average < 40) {
                  meterValue = 3;
                } else {
                  meterValue = meterValue + 25;
                  meterValue = parseInt(meterValue.toString()[0]);
                }
    
                for (var i = 0; i < bars.length; i++) {
                  if (i < meterValue) {
                    bars[i].classList.add("on");
                  } else {
                    bars[i].classList.remove("on");
                  }
                }
    
                if ($scope.isMicrophoneOn) {
                  requestAnimationFrame(updateMicrophoneLevel);
                }
              }
    
              $scope.isMicrophoneOn = true;
              updateMicrophoneLevel();
            }
          ).catch(function (err) {
              console.error("Failed to get user media", err);
          });
        } else {
          console.error("getUserMedia not supported");
        }
      };
    
      $scope.stopMicrophoneLevel = function () {
        console.log('Stopping microphone...');
    
        if (mediaStream) {
            // Stop all tracks of the media stream
            mediaStream.getTracks().forEach(function(track) {
                track.stop();
            });
            mediaStream = null;  // Clear the mediaStream reference
        }
    
        if (audioContext) {
            audioContext.close().then(function() {
                audioContext = null;  // Clear the audioContext reference
                $scope.$applyAsync(function () {
                    $scope.isMicrophoneOn = false;
                    $scope.microphoneLevel = 0;
                });
            }).catch(function(error) {
                console.error('Error closing audio context:', error);
            });
        }
    };
    

       
    $scope.readyForCalls = function() {
      // $scope.stopMicrophoneLevel()
      $scope.runAudioVisualizer()
        $scope.showCallStatusPrompt = false; 
        $scope.showAudioTestPrompt = true;
        $scope.step = 0;
        // Call the startMicrophone function to begin capturing audio
        
    }; 

    $scope.volume = 100;
    
    $scope.setVolume = function(volume) {
      var normalizedVolume = persistSpeakerTestVolume(volume);
      $scope.volume = normalizedVolume;
        var audio = document.getElementById('audioElement');
      if (audio) {
        audio.volume = normalizedVolume / 100;
      }
      syncVolumeControlVisual(normalizedVolume);
    };

    $scope.runAudioVisualizer = function() {
  
        
        $timeout(function() {
            var audio = document.getElementById("audioElement");
        var normalizedVolume = persistSpeakerTestVolume($scope.volume);
        $scope.volume = normalizedVolume;
            // Set output device if selected
            var startPlayback = function() {
                audio.play().then(function() {
                    $scope.$applyAsync(function() {
                        $scope.speakerTestPassed = true;
                    });
                }).catch(function(error) {
                    console.error('Audio play failed:', error);
                    $scope.$applyAsync(function() {
                        $scope.speakerTestPassed = false;
                    });
                });
            };
            var selectedSinkId = $scope.deviceSelection.outputId === 'default' ? '' : $scope.deviceSelection.outputId;
            if (audio.setSinkId && $scope.deviceSelection.outputId) {
                audio.setSinkId(selectedSinkId).then(startPlayback).catch(function(err) {
                    console.error('Failed to set audio output device:', err);
                    startPlayback();
                });
            } else {
                startPlayback();
            }
            var contextOptions = {};
            if (selectedSinkId) {
                contextOptions.sinkId = selectedSinkId;
            }
            var context = new AudioContext(contextOptions);
            speakerTestAudioContext = context; // Store reference for device switching
            var src = context.createMediaElementSource(audio);
            var analyser = context.createAnalyser();
        
            var canvas = document.getElementById("audio-canvas");
            canvas.width = 560;
            canvas.height = 70;
            var ctx = canvas.getContext("2d");
        
            src.connect(analyser);
            analyser.connect(context.destination);
        
            analyser.fftSize = 256;
        
            var bufferLength = analyser.frequencyBinCount;
            console.log(bufferLength);
        
            var dataArray = new Uint8Array(bufferLength);
        
            var WIDTH = canvas.width;
            var HEIGHT = canvas.height;
        
            var barWidth = (WIDTH / bufferLength) * 2.5;
            var barHeight;
            var x = 0;
        
            function renderFrame() {
              requestAnimationFrame(renderFrame);
        
              x = 0;
        
              analyser.getByteFrequencyData(dataArray);
        
              ctx.fillStyle = "#fff";
              ctx.fillRect(0, 0, WIDTH, HEIGHT);
        
              for (var i = 0; i < bufferLength; i++) {
                barHeight = dataArray[i]/5;
                
                var r = barHeight + (25 * (i/bufferLength));
                var g = 250 * (i/bufferLength);
                var b = 50;
        
                ctx.fillStyle = "#22C55E";
                ctx.fillRect(x, HEIGHT - barHeight, barWidth, barHeight);
        
                x += barWidth + 1;
              }
            }
        
            audio.volume = normalizedVolume / 100;
            // audio.play(); removed duplicate

            syncVolumeControlVisual(normalizedVolume);

            var volumeControl = document.querySelector('.custom-volume-control');
            if (volumeControl && !volumeControl.dataset.volumeStyleBound) {
              volumeControl.dataset.volumeStyleBound = 'true';
              volumeControl.addEventListener('input', function() {
                this.style.setProperty('--value', this.value + '%');
              });
            }

            renderFrame();
            // audio.play(); removed duplicate
            audio.addEventListener('ended', function() {
                audio.currentTime = 0; // Restart the audio
                audio.play();
            });
        });

    }; 


    $scope.confirmAudioSpeakerTest = function(answer) {
        if (answer === 'Yes') {
            if (!$scope.speakerTestPassed) {
                toaster.pop('error', 'Speaker Test Failed', 'Please enable sound and allow speaker permissions in your browser settings.');
                return;
            }
          $scope.startMicrophoneLevel();
            // console.log("test microPhone")
            $scope.showAudioTestPrompt = false;
            $scope.showMicrophonePrompt = true;
            $scope.step = 1; 
        } else if (answer === 'No') {
            $modalInstance.close(false);    
        }
    };

    $scope.confirmMicrophoneTest = function(answer) {
        if (answer === 'Yes') {
            if (!mediaStream) {
                toaster.pop('error', 'Microphone Permission Denied', 'Please allow microphone permission in your browser settings.');
                return;
            }
            $scope.stopMicrophoneLevel();
            $scope.showReadyCallPrompt = true;
            $scope.showMicrophonePrompt = false;      
            $scope.step = 2;
        } else if (answer === 'No') {
            $modalInstance.close(false); 
        }
    }

    $scope.backToCall = function(answer) {
        if(answer === 'Yes'){
      if (speakerTestAudioContext) {
        speakerTestAudioContext.close().catch(function() {});
        speakerTestAudioContext = null;
      }
            console.log("back to call")
            $modalInstance.close(true);
            $scope.step = 3;
        }else if (answer === 'No') {
            $modalInstance.close(false);    
        }
       
    }; 

    $scope.$on('$destroy', function() {
      $scope.stopMicrophoneLevel();
    });

    $scope.$watch('step', function(newStep, oldStep) {
        // console.log(newStep, oldStep,"from watch function")
       // var iconHtml = '<i class="fa fa-check-circle" style="font-size:35px;color: #2196f3"></i>';
        var iconHtml = '<img src="img/bluecheck.png" style="width: 35px; height: 35px;">';
        if (newStep === 1) {
            $('.step:nth-child(1)').css({
                'background-size': 'cover',
                'background-position': 'center',
                'background-color':'white',
                'width': '35px', 
                'height': '35px', 
            }).empty().append(iconHtml);
            $('.number:nth-child(1)').css('color', 'white');
        } else if (newStep === 2) {
            $('.step:nth-child(2)').css({
                'background-size': 'cover',
                'background-position': 'center',
                'background-color':'white',
                'width': '35px', 
                'height': '35px', 
            }).empty().append(iconHtml);
            $('.number:nth-child(2)').css('color', 'white');
        } else if (newStep === 3) {
            $('.step:nth-child(3)').css({
                'background-size': 'cover',
                'background-position': 'center',
                'background-color':'white',
                'width': '35px', 
                'height': '35px', 
            }).empty().append(iconHtml);
            $('.number:nth-child(3)').css('color', 'white');
        }
    });

}]);